var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mx-n2"
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.loadStatus
    }
  }), _vm.show && _vm.html ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "420",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.html = null;
      }
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right ma-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.show = null;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', {
    domProps: {
      "textContent": _vm._s(_vm.TITLES[_vm.show])
    }
  }), _c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  })], 1)], 1) : _vm._e(), _c('v-btn', {
    staticClass: "px-2",
    attrs: {
      "text": "",
      "x-small": "",
      "color": "primary",
      "loading": _vm.show == 'description' && !_vm.html
    },
    on: {
      "click": function ($event) {
        _vm.show = 'description';
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiInformation)
    }
  }), _vm._v(" Description ")], 1), _c('v-btn', {
    staticClass: "px-2",
    attrs: {
      "text": "",
      "x-small": "",
      "color": "primary",
      "loading": _vm.show == 'disclosure' && !_vm.html
    },
    on: {
      "click": function ($event) {
        _vm.show = 'disclosure';
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiFileDocument)
    }
  }), _vm._v(" Terms & conditions ")], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }